import { render, staticRenderFns } from "./couponSettings.vue?vue&type=template&id=3d78254c&scoped=true&"
import script from "./couponSettings.vue?vue&type=script&lang=js&"
export * from "./couponSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d78254c",
  null
  
)

export default component.exports